import React from 'react';
import { Link } from 'react-router-dom';
import { GraduationCapIcon } from 'lucide-react';
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-navy-dark text-white pt-16 pb-8" data-id="element-53">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-54">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12" data-id="element-55">
          {/* Brand Col */}
          <div className="col-span-1 md:col-span-1" data-id="element-56">
            <Link to="/" className="flex items-center mb-4" data-id="element-57">
              <GraduationCapIcon className="h-8 w-8 text-gold mr-2" data-id="element-58" />
              <span className="text-xl font-bold text-white tracking-tight" data-id="element-59">
                OnlineCollege<span className="text-gold" data-id="element-60">Guide</span>
              </span>
            </Link>
            <p className="text-gray-400 text-sm leading-relaxed mb-6" data-id="element-61">
              Empowering students to find the perfect online degree program to
              advance their careers and achieve their goals.
            </p>
          </div>

          {/* Links Col 1 */}
          <div data-id="element-62">
            <h3 className="text-sm font-bold uppercase tracking-wider text-gray-300 mb-4" data-id="element-63">
              Top Programs
            </h3>
            <ul className="space-y-3" data-id="element-64">
              <li data-id="element-65">
                <Link to="/degrees/business" className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-66">
                  Business Administration
                </Link>
              </li>
              <li data-id="element-67">
                <Link to="/degrees/computer-science" className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-68">
                  Computer Science
                </Link>
              </li>
              <li data-id="element-69">
                <Link to="/degrees/healthcare" className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-70">
                  Nursing & Healthcare
                </Link>
              </li>
              <li data-id="element-71">
                <Link to="/degrees/psychology" className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-72">
                  Psychology
                </Link>
              </li>
            </ul>
          </div>

          {/* Links Col 2 */}
          <div data-id="element-73">
            <h3 className="text-sm font-bold uppercase tracking-wider text-gray-300 mb-4" data-id="element-74">
              Resources
            </h3>
            <ul className="space-y-3 mb-6" data-id="element-75">
              <li data-id="element-76">
                <Link to="/colleges" className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-77">
                  Partner Colleges
                </Link>
              </li>
            </ul>
            <h3 className="text-sm font-bold uppercase tracking-wider text-gray-300 mb-4" data-id="element-78">
              Guides
            </h3>
            <ul className="space-y-3" data-id="element-79">
              <li data-id="element-80">
                <Link to="#" className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-81">
                  Financial Aid Guide
                </Link>
              </li>
              <li data-id="element-82">
                <Link to="#" className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-83">
                  Accreditation Info
                </Link>
              </li>
              <li data-id="element-84">
                <Link to="#" className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-85">
                  Career Paths
                </Link>
              </li>
              <li data-id="element-86">
                <Link to="#" className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-87">
                  Student Success Stories
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal Col */}
          <div data-id="element-88">
            <h3 className="text-sm font-bold uppercase tracking-wider text-gray-300 mb-4" data-id="element-89">
              Legal
            </h3>
            <ul className="space-y-3" data-id="element-90">
              <li data-id="element-91">
                <Link to="#" className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-92">
                  Privacy Policy
                </Link>
              </li>
              <li data-id="element-93">
                <Link to="#" className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-94">
                  Terms of Service
                </Link>
              </li>
              <li data-id="element-95">
                <Link to="#" className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-96">
                  Cookie Policy
                </Link>
              </li>
              <li data-id="element-97">
                <Link to="#" className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-98">
                  Do Not Sell My Info
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 pt-8" data-id="element-99">
          <div className="text-xs text-gray-400 space-y-4 text-center md:text-left" data-id="element-100">
            <p data-id="element-101">
              <strong data-id="element-102">Advertiser Disclosure:</strong> OnlineCollegeGuide.com is
              an advertising-supported site. Featured or trusted partner
              programs and all school search, finder, or match results are for
              schools that compensate us. This compensation does not influence
              our school rankings, resource guides, or other
              editorially-independent information published on this site.
            </p>
            <p data-id="element-103">
              <strong data-id="element-104">TCPA Disclosure:</strong> By submitting your information
              on this website, you consent to be contacted by our educational
              partners regarding their programs via email, telephone, or text
              message.
            </p>
            <p className="pt-4 text-gray-500" data-id="element-105">
              &copy; {currentYear} OnlineCollegeGuide. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>;
}